import type { DataGridFilterState, TableFilterState } from '@ibsys/kit';
import { replaceEqualDeep } from '@tanstack/react-query';
import { useMemo, useState } from 'react';
import { toDataGridFilters } from './dataGridAdapters';

/**
 * Фильтры таблицы в формате DataGrid, где отбор, значение которого не изменилось, остаётся тем же
 * объектом. Карточка панели фильтров держит черновик — набранное, но не применённое — и заменяет
 * его значением отбора, как только оно приходит другим объектом, даже равным прежнему. Конвертация
 * пересоздаёт все значения на любое изменение отборов, и применение, сброс или удаление одной
 * карточки откатывали бы не применённое в соседних.
 */
export const useDataGridFilters = (filters: TableFilterState): DataGridFilterState => {
  const converted = useMemo(() => toDataGridFilters(filters), [filters]);
  const [shared, setShared] = useState(converted);
  const next = replaceEqualDeep(shared, converted);
  if (next !== shared) setShared(next);
  return next;
};
